export enum standardsContent {
  STANDARDS = 'Standards',
  ADDRESSING = 'Addressing',
  BUILDING_TOWARDS = 'Building Towards',
  BUILDING_ON = 'Building on',
}
